export interface DocumentsSearchPayload {
  page: number;
  pageSize: number;
  memberId: string;
  searchTerm: string;
}

export interface ContextSearchDocumentItem {
  id: string;
  name: string;
  link: string;
  type: string;
  description: string;
  tags: string[];
  documentDate: string;
}

export interface DocumentsContextSearchResponse {
  content: string;
  documents: ContextSearchDocumentItem[];
}
